import styled from 'styled-components';

export const LoaderWrapper =  styled.div`
  z-index: 2;
  text-align: center;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
`;
